import { AuthRepository } from "@/domain/repository/auth-repository";
import { LoginRepository } from "@/domain/repository/login-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

export class LogoutUsecase {
  constructor(
    private readonly loginRepo: LoginRepository,
    private readonly authRepo: AuthRepository,
  ) {}

  async execute(): Promise<SATResult<void, SATError>> {
    const logoutResult = await this.loginRepo.logout();
    const clearResult = await this.authRepo.clearAuthStorage();
    if (logoutResult.isFailure) {
      return SATResult.failure(logoutResult.error);
    }
    if (clearResult.isFailure) {
      return SATResult.failure(clearResult.error);
    }
    return SATResult.success(void 0);
  }
}
